import React from 'react';
import { logger } from '../utils/logger';
import { Modal, Button, Typography, Space, Divider } from 'antd';
import { CrownOutlined, StarOutlined } from '@ant-design/icons';


const { Title, Paragraph, Text } = Typography;

const AIUpgradePrompt = ({ 
  visible, 
  onCancel, 
  limitInfo,
  onUpgrade 
}) => {

  const getUpgradeMessage = () => {
    if (!limitInfo) {
      return {
        title: 'AI 功能需要升級',
        description: '您已達到當前方案的 AI 查詢次數上限，請升級以獲得更多查詢次數。'
      };
    }

    const { accessTier, limit } = limitInfo;
    
    if (accessTier === 'guest') {
      return {
        title: '未登入用戶 AI 分析查詢次數已用完',
        description: `您本月已使用 ${limit} 次 AI 查詢。登錄後可獲得更多查詢次數。`,
        currentPlan: '未登入',
        upgradePlan: '登錄',
        benefits: [
          '登錄後可獲得每個月 20 次 AI分析查詢',
          '無限制股票代碼查詢',
          '無限制股票篩選',
          '個人化收藏列表',
          '更多進階功能'
        ]
      };
    } else if (accessTier === 'free') {
      return {
        title: '免費方案 AI 查詢次數已用完',
        description: `您本月已使用 ${limit} 次 AI 查詢。升級到 Pro 方案可獲得 200 次額外查詢。`,
        currentPlan: 'FREE',
        upgradePlan: 'PRO',
        benefits: [
          'AI 查詢次數從 20 次增加到 200 次',
          '無限制股票篩選',
          '優先技術支援',
          '更多進階功能'
        ]
      };
    } else if (accessTier === 'pro') {
      return {
        title: 'Pro 方案 AI 查詢次數已用完',
        description: `您本月已使用 ${limit} 次 AI 查詢。升級到 Pro+ 方案可獲得更多查詢次數。`,
        currentPlan: 'PRO',
        upgradePlan: 'PRO+',
        benefits: [
          'AI 查詢次數進一步增加',
          '無限制所有功能',
          '專屬客服支援',
          '最新功能優先體驗'
        ]
      };
    }
    logger.info('accessTier', accessTier);
    return {
      title: 'AI 查詢次數已用完',
      description: `您本月已使用 ${limit} 次 AI 查詢。請升級以獲得更多查詢次數。`
    };
  };

  const message = getUpgradeMessage();

  return (
    <Modal
      title={
        <Space>
          <CrownOutlined style={{ color: '#faad14' }} />
          <span>升級方案</span>
        </Space>
      }
      open={visible}
      onCancel={onCancel}
      width={500}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          關閉
        </Button>,

      ]}
      centered
    >
      <div style={{ textAlign: 'center', marginBottom: '24px' }}>
        <Title level={3} style={{ color: '#1890ff', marginBottom: '8px' }}>
          {message.title}
        </Title>
        <Paragraph style={{ fontSize: '16px', marginBottom: '0' }}>
          {message.description}
        </Paragraph>
      </div>

      {message.currentPlan && message.upgradePlan && (
        <div style={{ marginBottom: '24px' }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            padding: '16px',
            backgroundColor: '#f5f5f5',
            borderRadius: '8px',
            marginBottom: '16px'
          }}>
            <div>
              <Text strong style={{ color: '#8c8c8c' }}>當前方案</Text>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#8c8c8c' }}>
                {message.currentPlan}
              </div>
            </div>
            <div style={{ fontSize: '24px', color: '#d9d9d9' }}>→</div>
            <div>
              <Text strong style={{ color: '#1890ff' }}>升級方案</Text>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1890ff' }}>
                {message.upgradePlan}
              </div>
            </div>
          </div>

          {message.benefits && (
            <div>
              <Text strong style={{ fontSize: '16px', marginBottom: '12px', display: 'block' }}>
                {message.currentPlan === '未登入' ? '註冊登錄後您將免費獲得：' : '升級後您將獲得：'}
              </Text>
              <Space direction="vertical" size="small" style={{ width: '100%' }}>
                {message.benefits.map((benefit, index) => (
                  <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                    <StarOutlined style={{ color: '#52c41a', marginRight: '8px' }} />
                    <Text>{benefit}</Text>
                  </div>
                ))}
              </Space>
            </div>
          )}
        </div>
      )}

      <Divider />
      
      <div style={{ textAlign: 'center' }}>
        <Text type="secondary" style={{ fontSize: '14px' }}>
          登入或升級後即生效，次月重置查詢次數
        </Text>
      </div>
    </Modal>
  );
};

export default AIUpgradePrompt;
